/**
   * Maps file extensions to programming language identifiers for syntax highlighting
   */
export const SOURCE_CODE_EXTENSIONS: { [ext: string]: string } = {
    '.feature': 'cucumber',
    '.abap': 'abap',
    '.adb': 'ada',
    '.ads': 'ada',
    '.ada': 'ada',
    '.ahk': 'ahk',
    '.ahkl': 'ahk',
    '.htaccess': 'apacheconf',
    '.apache.conf': 'apacheconf',
    '.apache2.conf': 'apacheconf',
    '.applescript': 'applescript',
    '.as': 'actionscript',
    '.asy': 'asy',
    '.sh': 'bash',
    '.ksh': 'bash',
    '.bash': 'bash',
    '.ebuild': 'bash',
    '.eclass': 'bash',
    '.bat': 'bat',
    '.cmd': 'bat',
    '.befunge': 'befunge',
    '.bmx': 'blitzmax',
    '.boo': 'boo',
    '.bf': 'brainfuck',
    '.b': 'brainfuck',
    '.c': 'c',
    '.h': 'c',
    '.cfm': 'cfm',
    '.cfml': 'cfm',
    '.cfc': 'cfm',
    '.tmpl': 'cheetah',
    '.spt': 'cheetah',
    '.cl': 'commonlisp',
    '.lisp': 'commonlisp',
    '.el': 'commonlisp',
    '.clj': 'clojure',
    '.cljs': 'clojure',
    '.cmake': 'cmake',
    '.coffee': 'coffeescript',
    '.sh-session': 'console',
    '.control': 'control',
    '.cpp': 'cpp',
    '.hpp': 'cpp',
    '.c++': 'cpp',
    '.h++': 'cpp',
    '.cc': 'cpp',
    '.hh': 'cpp',
    '.cxx': 'cpp',
    '.hxx': 'cpp',
    '.pde': 'cpp',
    '.cs': 'csharp',
    '.css': 'css',
    '.pyx': 'cython',
    '.pxd': 'cython',
    '.pxi': 'cython',
    '.d': 'd',
    '.di': 'd',
    '.pas': 'delphi',
    '.diff': 'diff',
    '.patch': 'diff',
    '.dpatch': 'dpatch',
    '.darcspatch': 'dpatch',
    '.duel': 'duel',
    '.jbst': 'duel',
    '.dylan': 'dylan',
    '.dyl': 'dylan',
    '.erb': 'erb',
    '.erl-sh': 'erl',
    '.erl': 'erlang',
    '.hrl': 'erlang',
    '.evoque': 'evoque',
    '.factor': 'factor',
    '.flx': 'felix',
    '.flxh': 'felix',
    '.f': 'fortran',
    '.f90': 'fortran',
    '.s': 'gas',
    '.S': 'gas',
    '.kid': 'genshi',
    '.gitignore': 'gitignore',
    '.vert': 'glsl',
    '.frag': 'glsl',
    '.geo': 'glsl',
    '.plot': 'gnuplot',
    '.plt': 'gnuplot',
    '.go': 'go',
    '.1': 'groff',
    '.2': 'groff',
    '.3': 'groff',
    '.4': 'groff',
    '.5': 'groff',
    '.6': 'groff',
    '.7': 'groff',
    '.man': 'groff',
    '.haml': 'haml',
    '.hs': 'haskell',
    '.html': 'html',
    '.htm': 'html',
    '.xhtml': 'html',
    '.xslt': 'html',
    '.hx': 'haxe',
    '.hy': 'hybris',
    '.hyb': 'hybris',
    '.ini': 'ini',
    '.cfg': 'ini',
    '.io': 'io',
    '.ik': 'ioke',
    '.weechatlog': 'irc',
    '.jade': 'jade',
    '.java': 'java',
    '.js': 'javascript',
    '.jsp': 'jsp',
    '.lhs': 'lhs',
    '.ll': 'llvm',
    '.lgt': 'logtalk',
    '.lua': 'lua',
    '.wlua': 'lua',
    '.mak': 'makefile',
    '.Makefile': 'makefile',
    '.makefile': 'makefile',
    '.GNUmakefile': 'makefile',
    '.mao': 'mako',
    '.maql': 'maql',
    '.mhtml': 'mason',
    '.mc': 'mason',
    '.mi': 'mason',
    '.autohandler': 'mason',
    '.dhandler': 'mason',
    '.md': 'markdown',
    '.mo': 'modelica',
    '.def': 'modula2',
    '.mod': 'modula2',
    '.moo': 'moocode',
    '.mu': 'mupad',
    '.mxml': 'mxml',
    '.myt': 'myghty',
    '.autodelegate': 'myghty',
    '.asm': 'nasm',
    '.ASM': 'nasm',
    '.ns2': 'newspeak',
    '.objdump': 'objdump',
    '.m': 'objectivec',
    '.j': 'objectivej',
    '.ml': 'ocaml',
    '.mli': 'ocaml',
    '.mll': 'ocaml',
    '.mly': 'ocaml',
    '.ooc': 'ooc',
    '.pl': 'perl',
    '.pm': 'perl',
    '.php': 'php',
    '.php3': 'php',
    '.php4': 'php',
    '.php5': 'php',
    '.ps': 'postscript',
    '.eps': 'postscript',
    '.pot': 'pot',
    '.po': 'po',
    '.pov': 'pov',
    '.inc': 'pov',
    '.prolog': 'prolog',
    '.pro': 'prolog',
    '.properties': 'properties',
    '.proto': 'protobuf',
    '.py3tb': 'py3tb',
    '.pytb': 'pytb',
    '.py': 'python',
    '.pyw': 'python',
    '.sc': 'python',
    '.SConstruct': 'python',
    '.SConscript': 'python',
    '.tac': 'python',
    '.R': 'r',
    '.Rout': 'rconsole',
    '.rb': 'ruby',
    '.rbw': 'ruby',
    '.Rakefile': 'ruby',
    '.rake': 'ruby',
    '.gemspec': 'ruby',
    '.rbx': 'ruby',
    '.duby': 'ruby',
    '.r': 'rebol',
    '.r3': 'rebol',
    '.cw': 'redcode',
    '.rhtml': 'rhtml',
    '.rst': 'rst',
    '.rest': 'rst',
    '.sass': 'sass',
    '.scala': 'scala',
    '.scaml': 'scaml',
    '.scm': 'scheme',
    '.scss': 'scss',
    '.st': 'smalltalk',
    '.tpl': 'smarty',
    '.sources.list': 'sourceslist',
    '.sql': 'sql',
    '.sqlite3-console': 'sqlite3',
    '.squid.conf': 'squidconf',
    '.ssp': 'ssp',
    '.tcl': 'tcl',
    '.tcsh': 'tcsh',
    '.csh': 'csh',
    '.tex': 'tex',
    '.aux': 'tex',
    '.toc': 'tex',
    '.txt': 'text',
    '.v': 'verilog',
    '.sv': 'systemverilog',
    '.vala': 'vala',
    '.vapi': 'vala',
    '.vb': 'vbnet',
    '.bas': 'vbnet',
    '.vm': 'velocity',
    '.fhtml': 'velocity',
    '.vim': 'vim',
    '.vimrc': 'vim',
    '.xml': 'xml',
    '.xsl': 'xml',
    '.rss': 'xml',
    '.xsd': 'xml',
    '.wsdl': 'xml',
    '.xqy': 'xquery',
    '.xquery': 'xquery',
    '.yaml': 'yaml',
    '.yml': 'yaml',
    '.ts': 'typescript',
    '.tsx': 'typescript',
    '.json': 'json',
    '.kt': 'kotlin',
    '.kts': 'kotlin',
    '.swift': 'swift',
    '.rs': 'rust',
    '.dart': 'dart',
};
